import { useTranslation } from 'react-i18next';
import { Navigate, useNavigate } from 'react-router-dom';

import { Result, Space, Typography } from 'antd';
import LIEnquirySubmittedIcon from 'assets/images/MakeRequest/sucesspageicon.svg';

import { PrimaryButton } from 'components';

interface EnquiryData {
  enquiryReference: string;
}

export const EnquirySuccessPage = ({ enquiryReference }: EnquiryData) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  if (!enquiryReference) {
    return <Navigate to="/notFound" replace={true} />;
  }

  return (
    <Result
      style={{ width: '100%' }}
      className="lifesucess"
      title={t('life.submitClaims.sucsesspagetittle')}
      icon={<img style={{ width: '176px', height: '176px' }} src={LIEnquirySubmittedIcon} />}
      extra={
        <Space direction="vertical">
          <Typography.Text style={{ fontFamily: 'Roboto400', fontSize: '24px', color: '#6f7072' }}>
            <span>{t('life.submitClaims.sucsesspagetext1')}</span>
          </Typography.Text>
          <Typography.Text style={{ fontFamily: 'Roboto400', fontSize: '24px', color: '#6f7072' }}>
            <span>{t('life.submitClaims.sucsesspagetext2')}</span>
          </Typography.Text>
          <Typography.Text style={{ fontFamily: 'Roboto400', fontSize: '24px', color: '#6f7072' }}>
            <span>{`${t('life.submitClaims.sucsesspagetext3')}${enquiryReference}`}</span>
          </Typography.Text>
          <PrimaryButton
            className="sucsesPrimaryButton"
            style={{ height: '56px', fontFamily: 'Roboto500', fontSize: '20px', marginTop: '15px' }}
            onClick={() => navigate('/LIHome')}
          >
            {t('common.done')}
          </PrimaryButton>
        </Space>
      }
    />
  );
};
